import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderDownloadMobileDropdown = (data) => openPopupHelper({ popupName: popupNames.DOWNLOAD_MOBILE, data });
